/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { fastestLapsApi } from './FastestLapsApi';
import { MotorsportsError, MotorsportsErrorType } from 'services/motorsportsError/MotorsportsError';
import { FastDataResponse, LapAnalysisRequest } from 'models/viewModels';
import { AxiosError } from 'axios';

class FastestLapsService {
  async getFastestLaps(request: LapAnalysisRequest): Promise<FastDataResponse> {
    return fastestLapsApi
      .getFastestLaps(request)
      .then((response) => response)
      .catch((error: AxiosError) => {
        if (error.code === 'ERR_BAD_REQUEST') {
          throw new MotorsportsError(
            `xLap: ${request.requestedLapNumber}, threshold: ${request.threshold}`,
            MotorsportsErrorType.EventNotFound,
            { cause: error }
          );
        }
        throw new MotorsportsError(error.message, MotorsportsErrorType.Unknown, { cause: error });
      });
  }
}

export const fastestLapsService = new FastestLapsService();
